export const messages = {
  title: {
    id: 'admin/promotions.form.storefront.additional-information.title',
  },
  subtitle: {
    id: 'admin/promotions.form.storefront.additional-information.subtitle',
  },
  name: {
    id: 'admin/promotions.form.storefront.additional-information.name',
  },
  value: {
    id: 'admin/promotions.form.storefront.additional-information.value',
  },
  edit: { id: 'admin/promotions.utils.edit' },
  create: { id: 'admin/promotions.utils.create' },
  remove: { id: 'admin/promotions.utils.remove' },
  add: { id: 'admin/promotions.utils.add' },
  count: { id: 'admin/promotions.form.utils.count' },
  cancel: { id: 'admin/promotions.utils.cancel' },
  discard: { id: 'admin/promotions.utils.discard' },
  save: { id: 'admin/promotions.utils.save' },

  validation: {
    required: { id: 'admin/promotions.form.validation.required' },
    unique: {
      id: 'admin/promotions.form.validation.additional-information.name.unique',
    },
  },
}
